import React from 'react';
import './header.css';
import { useUsers } from '../../context/usersContext';
import ImgLogout from '../../assets/logoutazul.png';
import { getTrainingEnvironmentMessage } from '../../utils/runtimeEnvironment';

const Header = () => {
  const {
    logout,
    userInfo,
    userUnits,
    hasMultipleUnits,
    effectiveUnitId,
    setActiveUnitId,
  } = useUsers();

  // Função para logout manual
  const handleLogout = () => {
    logout();
  };

  // Fallback para evitar tela branca quando dados do usuario ainda nao carregaram.
  const firstName = userInfo?.first_name || userInfo?.username || userInfo?.email || 'Usuário';
  const selectedUnit = userUnits.find(
    (unit) => String(unit.id) === String(effectiveUnitId)
  );
  const unitAcronym = selectedUnit?.acronym || selectedUnit?.name || userInfo?.unit_acronym || 'SEJUS';
  const trainingEnvironmentMessage = getTrainingEnvironmentMessage();
  const handleUnitChange = (event) => {
    const nextUnitId = event.target.value;
    if (String(nextUnitId) === String(effectiveUnitId ?? '')) {
      return;
    }

    setActiveUnitId(nextUnitId);
    // Redireciona para Home para recarregar o escopo completo da unidade ativa.
    window.location.assign('/');
  };

  return (
    <div className='header'>
      <div className="header-left">
        {trainingEnvironmentMessage ? (
          <span className="header-training-badge">{trainingEnvironmentMessage}</span>
        ) : null}
      </div>

      <div className="header-right">
        <div className="profile">
          <h3>Ola! {firstName}</h3>
          {hasMultipleUnits ? (
            <div className="header-unit-switcher">
              <select
                id="header-unit-select"
                value={effectiveUnitId ?? ''}
                onChange={handleUnitChange}
              >
                {userUnits.map((unit) => (
                  <option key={unit.id} value={unit.id}>
                    {unit.acronym || unit.name}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <p>{unitAcronym}</p>
          )}
        </div>
        <button id="log_out" onClick={handleLogout}>
          <img src={ImgLogout} alt='incone'></img>
        </button>
      </div>
    </div >
  )
}

export default Header;
